"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimitiveResolver = void 0;
const resolver_1 = require("./resolver");
class PrimitiveResolver extends resolver_1.Resolver {
    constructor(defaultValues) {
        super(defaultValues);
    }
    static replaceCriteria(message, key, value) {
        return message.replace(new RegExp('\\{' + key + '}', 'g'), String(value));
    }
    resolveCriteria(message, key, value) {
        let resolvedMessage = message;
        if (PrimitiveResolver.isPrimitiveValueType(value)) {
            const valueToResolve = value;
            resolvedMessage = PrimitiveResolver.replaceCriteria(message, key, valueToResolve);
        }
        else if (PrimitiveResolver.isPrimitiveFnValueType(key, value)) {
            const valueToResolve = value(key);
            resolvedMessage = PrimitiveResolver.replaceCriteria(message, key, valueToResolve);
        }
        return resolvedMessage;
    }
}
exports.PrimitiveResolver = PrimitiveResolver;
PrimitiveResolver.isPrimitiveValueType = (value) => {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
};
PrimitiveResolver.isPrimitiveFnValueType = (key, value) => {
    try {
        return PrimitiveResolver.isPrimitiveValueType(value(key));
    }
    catch (_a) {
        return false;
    }
};
//# sourceMappingURL=primitiveResolver.js.map